import { render } from "./ApproachView.vue?vue&type=template&id=556b3143"
import script from "./ApproachView.vue?vue&type=script&lang=js"
export * from "./ApproachView.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__